<odx-modal-header>
  <odx-area-header>{{ modalRef.data.title }}</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <p>{{ modalRef.data.description }}</p>
  @if (modalRef.data.fileNames?.length) {
    <p class="section-title">{{ modalRef.data.fileListTitle }}</p>
    <ul>
      <li *ngFor="let fileName of modalRef.data.fileNames">{{ fileName }}</li>
    </ul>
  }
  <p class="section-title">{{ modalRef.data.reasonTitle }}</p>
  <p>{{ modalRef.data.reason }}</p>
  <p class="section-title">{{ modalRef.data.solutionTitle }}</p>
  <ul>
    <li *ngFor="let solution of modalRef.data.solutions">{{ solution }}</li>
  </ul>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="primary" (click)="onConfirm()">{{ modalRef.data.closeLabel }}</button>
</odx-modal-footer>
